





















import { Vue, Component } from 'vue-property-decorator'
import { ItemInstruction } from '../models'
import LinksStore from '../components/LinksStore.vue'

@Component({
  components: {
    LinksStore
  }
})

export default class ItemsInstructions extends Vue {
  items: ItemInstruction[] = [
    { descr: 'При регистрации в&nbsp;приложении WB&nbsp;Партнеры выберите пункт стать самозанятым', img: '/static/images/instructions-1.png', title: 'Прикрепитесь' },
    { descr: 'Скачайте приложение &laquo;Мой налог&raquo; в&nbsp;App&nbsp;Store или Google&nbsp;Play, затем зарегистрируйтесь по&nbsp;паспорту&nbsp;РФ или личному кабинету налогоплательщика',
      img: '/static/images/instructions-2.png', title: 'Скачайте мой налог' },
    { descr: 'Завершите регистрацию и&nbsp;получите статус плательщика налога на&nbsp;профессиональных доход (НПД). Возвращайтесь в&nbsp;приложение &laquo;WB&nbsp;Партнеры&raquo; и&nbsp;завершите регистрацию используя ИНН',
      img: '/static/images/instructions-3.png', title: 'Завершите' },
  ]
  activeIndex: number = 0
  links = [
    { img: '/static/images/google-play.png', link: 'https://play.google.com/store/apps/details?id=com.gnivts.selfemployed&hl=ru' },
    { img: '/static/images/app-store.png', link: 'https://itunes.apple.com/ru/app/id1437518854' },
  ]

  get breakpoint() { return this.$store.state.breakpoint }
  get isLtMd() { return this.breakpoint === 'xs' || this.breakpoint === 'sm' }
  get imgs() { return this.items.map(i => i.img) }
  get activeImg() { return this.items[this.activeIndex].img }
}
